export default "__VITE_ASSET__yo9AzChAplQfaqrEBuKeXw__"